import { crearWhatsAppUrl } from '../../../utils/contactos';

export const TEVEO_CONFIG = {
  playerUrl:
    'https://teveo.com.co/player/AcAAAgBFAA43A1IAyADIUDAAAAGAAAAA.js?pid=teveo',
  scriptId: 'teveo-capsos-player-script',
  initDelay: 150,
  loadTimeout: 12000,
};

export const CONTACT_LINKS = {
  info:
    crearWhatsAppUrl('envivo', 'Hola, quiero información sobre la señal en vivo.'),
  support:
    crearWhatsAppUrl('envivo', 'Hola, quiero soporte o más información sobre la señal en vivo.'),
};

export const LIVE_INFO_ITEMS = [
  {
    icon: 'fas fa-tv',
    title: 'Señal digital',
    description: 'Acceso directo a la transmisión actual.',
  },
  {
    icon: 'fas fa-mobile-alt',
    title: 'Multidispositivo',
    description: 'Disponible en computador, tablet y celular.',
  },
  {
    icon: 'fas fa-headset',
    title: 'Acompañamiento',
    description: 'Atención disponible para soporte e información.',
  },
];

export const LIVE_SUPPORT_CARDS = [
  {
    icon: 'fas fa-satellite-dish',
    title: 'Acceso continuo',
    description:
      'Consulta la señal y mantente al día con emisiones, eventos y contenidos en tiempo real.',
  },
  {
    icon: 'fas fa-globe',
    title: 'Disponible en línea',
    description:
      'Accede desde diferentes lugares y dispositivos a la programación institucional y local.',
  },
  {
    icon: 'fas fa-comments',
    title: 'Soporte e información',
    description:
      'Comunícate con nuestro equipo cuando necesites ayuda para acceder a la transmisión.',
  },
];
